/* lefelin — Article v2 : barre de progression de lecture + FAQ accordéon.
   Progressive enhancement : sans JS, les réponses de la FAQ restent visibles
   (voir lf-article-v2.css, .lf2-faq--ready). */
(function () {
  function init() {
    var bar = document.querySelector(".lf2-progress-bar");
    if (bar) {
      var update = function () {
        var h = document.documentElement;
        var max = h.scrollHeight - h.clientHeight;
        bar.style.width = (max > 0 ? Math.min(100, (h.scrollTop / max) * 100) : 0) + "%";
      };
      update();
      window.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);
    }

    Array.prototype.forEach.call(document.querySelectorAll(".lf2-faq"), function (faq) {
      faq.classList.add("lf2-faq--ready");
      var items = faq.querySelectorAll(".lf2-faq-item");
      Array.prototype.forEach.call(items, function (item) {
        var q = item.querySelector(".lf2-faq-q");
        if (!q) return;
        q.addEventListener("click", function () {
          var wasOpen = item.classList.contains("is-open");
          Array.prototype.forEach.call(items, function (it) {
            it.classList.remove("is-open");
            var b = it.querySelector(".lf2-faq-q");
            if (b) b.setAttribute("aria-expanded", "false");
          });
          if (!wasOpen) {
            item.classList.add("is-open");
            q.setAttribute("aria-expanded", "true");
          }
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
